import { Box} from "@mui/material";
import React from "react";
import { createStyles, makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      position: "relative",
      width: 668,
      height: 800,
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-start",
      transition: "all 0.3s ease-in-out",
      alignSelf: "flex-start",
      flex: "0 0 auto",
      

      "@media (max-width: 1400px)": {
        transform: "scale(calc(0.6 + (100vw - 768px) / (1400px - 768px) * 0.4))",
        transformOrigin: "top center",
      },
      "@media (max-width: 768px)": {
        transform: "scale(0.6)",
      },
      
      [theme.breakpoints.down('lg')]: {
        width: "100%",
        maxWidth: 600,
        height: "auto",
        aspectRatio: "668/800",
        transform: "none",
        transformOrigin: "center",
        alignItems: "center",
        alignSelf: "center",
        flex: "1 1 auto",
      },
      [theme.breakpoints.down('md')]: {
        width: "100%",
        maxWidth: 600,
        height: "auto",
        aspectRatio: "668/800",
        transform: "none",
        transformOrigin: "center",
        alignItems: "center",
        alignSelf: "center",
        flex: "1 1 auto",
      },
    },
    graphic: {
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      objectFit: "contain",
      [theme.breakpoints.down('lg')]: {
        position: "relative",
        width: "100%",
        height: "100%",
      },
      [theme.breakpoints.down('md')]: {
        position: "relative",
        width: "100%",
        height: "100%",
      },
    },
  })
);

export const HeroGraphic: React.FC = () => {
    const classes = useStyles();
    return (
    <Box className={classes.root}>
        <Box
            component="img"
            className={classes.graphic}
            src="https://cdn.prod.website-files.com/63fd958eb41ee76ac86a4ef6/641cb6170e8f3b9f7e2dd63d_Hero%20Graphic.svg"
            alt="NEX WORK hero graphic"
            loading="lazy"
        />
    </Box>
    )
}
